import styled from "styled-components";
import media from "styled-media-query";

export const SafeView = styled.div`
  display: flex;
  margin: 30px;
  padding-bottom: 50px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.p`
  font-size: 1.3rem;
  font-weight: bold;
`;

export const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
`;

export const TopSpace = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;

  ${media.greaterThan("medium")`
    width: 100%;
    height: 35%;
  `}
`;

export const Inputs = styled.div`
  margin-top: 2rem;
  align-items: center;
  justify-items: center;
`;

export const MiddleContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  align-items: center;
  font-size: 1.5rem;
  margin-bottom: 7rem;
  padding: 30px;
`;

export const Rounded = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #f57e38;
`;

export const BoxCheckbox = styled.div`
  height: 80%;
  display: flex;
  justify-content: flex-start;
  gap: 1.8rem;
  flex-direction: column;
`;

export const Footer = styled.div`
  margin-top: 25px;
  position: relative;
  bottom: 0;
  width: 100%;

  @media (max-width: 712px) {
    padding: 20px;
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }
`;
